/**
 * Possible statuses for cost waiver requests
 */
export var CostWaiverStatus;
(function (CostWaiverStatus) {
    /**
     * Cost waiver has been approved
     */
    CostWaiverStatus["Approved"] = "approved";
    /**
     * Cost waiver has been canceled due to the order being canceled
     */
    CostWaiverStatus["Canceled"] = "canceled";
    /**
     * Cost waiver has been requested and is awaiting approval
     */
    CostWaiverStatus["Pending"] = "pending";
    /**
     * Cost waiver has been rejected and the order has been returned to the customer
     */
    CostWaiverStatus["Rejected"] = "rejected";
})(CostWaiverStatus || (CostWaiverStatus = {}));
